import { Children, CSSProperties, ReactNode, SetStateAction, useEffect, useRef, useState } from "react";
import { Colours } from "../Themes/Colours";

export const InterfaceStyles = {
    flexOne : {
        display:'flex',
        flex:1,
    } as CSSProperties,
    center : {
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    } as CSSProperties,
    iconContainer : {
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        height:40,
        width:40,
    } as CSSProperties,
    standardColumn:{
        display:'flex',
        flexDirection: 'column',
        flexShrink:0,
        gap:10,
        overflow:'hidden',
    } as CSSProperties,
    standardRow:{
        display:'flex',
        height:40,
        flexShrink:0,
        gap:10,
        alignItems:'center',
    } as CSSProperties,
    settingsRow:{
        display:'flex',
        height:40,
        flexShrink:0,
        paddingRight:10,
        gap:10,
        boxSizing:"border-box",
        alignItems:'center',
    } as CSSProperties,
    elementRow:{
        display:'flex',
        height:40,
        flexShrink:0,
        paddingLeft:10,
        paddingRight:10,
        gap:10,
        boxSizing:"border-box",
        alignItems:'center',
        overflow:'hidden',
    } as CSSProperties,
    labelExtension:{
        display:'flex',
        height:40,
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:Colours.levelTwoBg,
        color:Colours.levelTwoText,
        boxSizing:'border-box',
    } as CSSProperties, 
    label:{
        display:'flex',
        height:40,
        alignItems:'center',
        padding:10,
        backgroundColor:Colours.levelTwoBg,
        color:Colours.levelTwoText,
        borderTopRightRadius:5,
        borderBottomRightRadius:5,
        boxSizing:'border-box',
    } as CSSProperties, 
    button:{
        display:'flex',
        flexDirection:'row',
        height:40,
        width:40,
        minWidth:40,
        gap:10,
        backgroundColor:Colours.levelOneBg,
        borderRadius:5,
        borderColor:Colours.levelThreeBg,
        borderStyle:'solid',
        borderWidth:1,
        alignItems:'center',
        justifyContent:'center',
        overflow:'hidden',
        boxSizing:"border-box",
        cursor:'pointer',
    } as CSSProperties,
    buttonToggleOn:{
        borderColor:Colours.orangeHighlightBg,
    } as CSSProperties,
    buttonText:{
        fontSize:16,
        color:Colours.levelTwoText,
        whiteSpace:'nowrap',
        overflow:'hidden'
    } as CSSProperties,
    buttonIconToggleOn:{
        color:Colours.orangeHighlightBg,
    } as CSSProperties,
    buttonIconToggleOff:{
        color:Colours.levelThreeBg,
    } as CSSProperties,
    floatingSection:{
        display:'flex',
        gap:10,
        flexDirection:'column',
        backgroundColor:Colours.levelOneBg,
        borderRadius:5,
        border: `1px solid ${Colours.levelThreeBg}`,
        overflow:'hidden',
        boxSizing:"border-box",
    } as CSSProperties,
    shadow:{
        boxShadow: "0px 4px 15px -7px rgba(0, 0, 0, 0.26)", 
    } as CSSProperties,
    input:{
        display:'flex',
        flex:1,
        height:40,
        backgroundColor:Colours.levelOneBg, 
        borderRadius:5, 
        color:Colours.levelTwoText,
        padding:0,
        paddingLeft:10,
        paddingRight:10, 
        border: `1px solid ${Colours.levelThreeBg}`,
        textAlign:'right',
        overflow:'hidden',
        outline:'none',
        boxSizing:"border-box",
        maxWidth:'100%',
        fontSize:16,
    } as CSSProperties,
};

export const InterfaceScroller = (props:{direction?:'horizontal' | 'vertical', children?:ReactNode, containerStyle?:CSSProperties, scrollerStyle?:CSSProperties}) => {

    const [direction, setDirection] = useState(props.direction ?? 'vertical');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(()=>{
        setDirection(props.direction ?? 'vertical');
    },[props.direction]);

    useEffect(()=>{
        const checkValue = window.navigator.userAgent.toLowerCase();
        checkValue.includes('iphone') && setIsMobile(true);
        checkValue.includes('android') && setIsMobile(true);
    },[]);

    return(
        <div style={{
            display:'flex',
            flex:1,
            flexDirection: direction === 'vertical' ? 'column' : 'row',
            boxSizing:"border-box",
            overflow:'hidden',
            ...props.containerStyle,
        }}>
            <div style={{
                display:'flex',
                flexDirection: direction === 'vertical' ? 'column' : 'row',
                overflowY: direction === 'vertical' ? 'scroll' : 'hidden',
                overflowX: direction === 'horizontal' ? 'scroll' : 'hidden',
                marginRight: direction === 'vertical' ? isMobile ? 0 : -15 : undefined,
                marginBottom: direction === 'horizontal' ? isMobile ? 0 : -15 : undefined,
                paddingBottom:10,
                paddingTop:10,
                gap:10,
                boxSizing:"border-box",
                ...props.scrollerStyle,
            }}>
                {props.children}
            </div>
        </div>
    );

};